module.exports = __webpack_public_path__ + "img/um.8b2e2aca.svg";